import { PlusIcon, MinusIcon } from "@/components/data-display/Icon";
import classNames from "classnames";

function ItemTab({ title, isOpen, onOpen, children }) {
  return (
    <article>
      <button
        className="w-full flex items-center justify-between"
        onClick={onOpen}
      >
        <p
          className={classNames({
            "text-primary font-semibold": isOpen,
            "text-grayD2": !isOpen,
          })}
        >
          {title}
        </p>
        {isOpen ? (
          <MinusIcon className="text-primary" />
        ) : (
          <PlusIcon className="text-primary w-[0.875rem] h-[0.875rem]" />
        )}
      </button>
      {isOpen && <div>{children}</div>}
    </article>
  );
}

export default ItemTab;
